export const coursewareGroupTableOption = {
  border: true,
  index: false,
  stripe: true,
  menuAlign: 'center',
  align: 'center',
  showClomnuBtn: false,
  searchSize: 'mini',
  refreshBtn: false,
  addBtn: false,
  editBtn: false,
  delBtn: false,
  column: [
    {
      label: '分组名称',
      prop: 'groupName',
      rules: [{
        required: true,
        message: '请输入课件分组名称',
        trigger: 'blur'
      }, {
        min: 1,
        max: 512,
        message: '长度在 1 到 512 个字符',
        trigger: 'blur'
      }]
    }, {
      label: '分组名称（英文）',
      prop: 'groupNameEn',
      labelWidth: 150,
      rules: [{
        message: '请输入课件分组英文名称',
        trigger: 'blur'
      }, {
        min: 1,
        max: 512,
        message: '长度在 1 到 512 个字符',
        trigger: 'blur'
      }]
    }, {
      label: '分组介绍',
      prop: 'groupDescription',
      solt: true,
      rules: [{
        min: 1,
        max: 512,
        message: '长度在 1 到 512 个字符',
        trigger: 'blur'
      }]
    }, {
      label: '分组介绍（英文）',
      prop: 'groupDescriptionEn',
      labelWidth: 150,
      rules: [{
        min: 1,
        max: 512,
        message: '长度在 1 到 512 个字符',
        trigger: 'blur'
      }]
    }
  ]
}

export const coursewareTypeOptions = [{
  label: 'PDF格式课件',
  value: 1
}, {
  label: '视频格式课件',
  value: 2
}]

export const coursewareCommentLimitCountOptions = [{
  label: '仅限一次',
  value: 1
}, {
  label: '不限',
  value: 2
}]

export const coursewareCommentTypeOptions = [{
  label: '图文九宫格',
  value: 1
}, {
  label: '文字',
  value: 2
}]

export const coursewareTimeUnitOptions = [{
  label: '分钟',
  value: 1
}, {
  label: '小时',
  value: 2,
}, {
  label: '天',
  value: 3,
}]

export const coursewareTimeUnitEnums = {
  DAY: {
    label: '天',
    value: 3,
    seconds: 86400,
  },
  HOUR: {
    label: '小时',
    value: 2,
    seconds: 3600,
  },
  MINUTE: {
    label: '分钟',
    value: 1,
    seconds: 60,
  },
}

export const coursewareFileTypeEnums = {
  IMAGE: {
    label: '封面图',
    value: 0,
    supportFormat: ['jpg', 'jpeg', 'png'],
  },
  PDF: {
    label: 'PDF格式课件',
    value: 1,
    supportFormat: ['pdf'],
  },
  VIDEO: {
    label: '视频格式课件',
    value: 2,
    supportFormat: ['mp4']

  }
}

export const coursewarelistTableOption = {
  border: true,
  stripe: true,
  align:'center',
  menuAlign:'center',
  delBtn: false,
  editBtn: false,
  addBtn: false,
  refreshBtn: false,
  searchBtn: false,
  searchShow: false,
  column: [{
    label: '名称',
    prop: 'name',
    width: 260,
    align: 'left',
    overHidden: true,
    solt: true,
  }, {
    label: '类型',
    prop: 'type',
    width: 120,
    align: 'left',
    dicData: coursewareTypeOptions,
  }, {
    label: '分组',
    prop: 'coursewareGroupId',
    width: 120,
    align: 'left',
    solt: true,
  }, {
    label: '长度',
    prop: 'coursewareLength',
    width: 120,
    align: 'left',
    overHidden: true,
    solt: true,
  }, {
    label: '建议学习时长',
    prop: 'coursewareTime',
    width: 120,
    align: 'left',
    overHidden: true,
    solt: true,
  }, {
    label: '创建时间',
    prop: 'insertedTime',
    align: 'left',
    overHidden: true,
    // sortable: true,
  }]
}

export const courseGroupTableOption = {
  border: true,
  index: false,
  stripe: true,
  menuAlign: 'center',
  align: 'center',
  showClomnuBtn: false,
  searchSize: 'mini',
  refreshBtn: false,
  addBtn: false,
  editBtn: false,
  delBtn: false,
  column: [
    {
      label: '分组名称',
      prop: 'groupName',
      rules: [{
        required: true,
        message: '请输入课程分组名称',
        trigger: 'blur'
      }, {
        min: 1,
        max: 512,
        message: '长度在 1 到 512 个字符',
        trigger: 'blur'
      }]
    }, {
      label: '分组名称（英文）',
      prop: 'groupNameEn',
      labelWidth: 150,
      rules: [{
        required: true,
        message: '请输入课程分组名称英文',
        trigger: 'blur',
      }, {
        min: 1,
        max: 512,
        message: '长度在 1 到 512 个字符',
        trigger: 'blur'
      }]
    }, {
      label: '分组介绍',
      prop: 'groupDescription',
      solt: true,
      rules: [{
        min: 1,
        max: 512,
        message: '长度在 1 到 512 个字符',
        trigger: 'blur'
      }]
    }, {
      label: '分组介绍（英文）',
      prop: 'groupDescriptionEn',
      labelWidth: 150,
      solt: true,
      rules: [{
        min: 1,
        max: 512,
        message: '长度在 1 到 512 个字符',
        trigger: 'blur'
      }]
    }, {
      label: '图标',
      prop: 'icon',
      formsolt: true,
      solt: true,
      rules: [{
        required: true,
        message: '请选择分组图标',
        trigger: 'blur'
      }]
    }, {
      label: '排序',
      prop: 'sort',
      formsolt: true,
    }
  ]
}

export const statusTypeOptions = [
  { value: 1, label: '已上架' },
  { value: 2, label: '已下架' }
]

export const learningStatusOptions = [
  { value: 2, label: '学习中' },
  { value: 3, label: '已完成' }
]

export const examStatusOptions = [
  { value: 1, label: '未参与' },
  { value: 2, label: '参与未通过' },
  { value: 3, label: '已通过' }
]

export const courseTypeOptions = [
  { value: 1, label: '公开课' },
  { value: 2, label: '指定范围用户参与' }
]

export const examConditions = [
  { value: 1, label: '不限制' },
  { value: 2, label: '课时完成' }
]

export const passConditions = [
  { value: 1, label: '课时完成' },
  { value: 2, label: '考试完成' },
  { value: 3, label: '考试通过' },
]

export const commentStatus = [
  { value: 0, label: '已上架' },
  { value: 1, label: '已下架' },
]

export const commentSections = [
  { value: 0, label: '查看所有评论' },
  { value: 1, label: '仅查看课程评论' },
]

export const courseGroupOptions = [
  { value: 1, label: '必修课程' },
]

export const coursewarePostIsBanned = [
  { value: 0, label: '否' },
  { value: 1, label: '是' },
]

export const learningStatusEnum = {
  UNSTART: {
    label: 'course.common.noStart',
    code: 1,
  },
  PROCESSING: {
    label: 'course.common.inProgress',
    code: 2,
  },
  FINISHED: {
    label: 'course.common.end',
    code: 3,
  },
}

export const coursewareSelectEnums = {
  PDF: {
    label: 'PDF',
    code: 1,
  },
  VIDEO: {
    label: '视频',
    code: 2,
  },
  CHECKIN: {
    label: '确认打卡',
    code: 3,
  },
  COMMENT: {
    label: '留言',
    code: 4,
  },
}

export const courseTypeEnums = {
  PUBLIC: {
    label: '公开课',
    code: 1,
  },
  PRIVATE: {
    label: '指定范围用户参与',
    code: 2,
  }
}

export const courseStatusEnums = {
  ACTIVE: {
    label: '已上架',
    code: 1,
  },
  INACTIVE: {
    label: '已下架',
    code: 2,
  }
}

export const commentIsBanned = [
  { value: 0, label: '否' },
  { value: 1, label: '是' },
]


export const courseTableOption = {
  border: true,
  index: false,
  stripe: true,
  menuAlign: 'center',
  align: 'center',
  showClomnuBtn: false,
  searchSize: 'mini',
  refreshBtn: false,
  addBtn: false,
  editBtn: false,
  delBtn: false,
  column: [
    {
      label: '状态',
      prop: 'status',
      width: 80,
      dicData: statusTypeOptions
    }, {
      label: '名称',
      prop: 'name',
      overHidden: true,
      solt: true,
      align: 'left',
      width: 260,
    }, {
      label: '课程二维码',
      prop: 'miniProgramCodeUrl',
      solt: true,
      align: 'left',
      width: 150,
    }, {
      label: '课程类型',
      prop: 'courseType',
      dicData: courseTypeOptions
    }, {
      label: '课程分组',
      prop: 'courseGroupId',
      overHidden: true,
      dicData: courseGroupOptions
    }, {
      label: '课时总数',
      prop: 'coursewareCount',
      overHidden: true,
    }, {
      label: '建议时长',
      prop: 'courseTime',
      overHidden: true,
      solt: true,
    }, {
      label: '排序',
      prop: 'sort',
      width: 80,
    }, {
      label: '总参与人数',
      prop: 'participationCount',
      overHidden: true,
    }, {
      label: '创建人',
      prop: 'creator',
      width: 150,
    }, {
      label: '创建时间',
      prop: 'insertedTime',
      overHidden: true,
    },
  ]
}

export const enrollmentTableOption = {
  border: true,
  index: false,
  stripe: true,
  menu:false,
  align: 'center',
  showClomnuBtn: false,
  searchSize: 'mini',
  refreshBtn: false,
  addBtn: false,
  editBtn: false,
  delBtn: false,
  column: [
    {
      label: '员工号',
      prop: 'unionId',
      width: 120,
      overHidden: true,
      fixed: true,
    }, {
      label: 'Birth Name',
      prop: 'realname',
      overHidden: true,
      width: 180,
      fixed: true,
    }, {
      label: 'Full Name',
      prop: 'nickname',
      overHidden: true,
      width: 180,
      fixed: true,
    }, {
      label: '手机号',
      prop: 'phoneNumber',
      solt: true,
      width: 160,
      overHidden: true,
    }, {
      label: 'Position Name',
      width: 200,
      prop: 'position',
      overHidden: true,
    }, {
      label: 'Organizational Unit Name',
      width: 200,
      prop: 'organizationalUnitName',
      overHidden: true,
    }, {
      label: '学习状态',
      prop: 'learningStatus',
      width: 100,
      overHidden: true,
      dicData: learningStatusOptions,
    }, {
      label: '完成率',
      prop: 'completeRate',
      width: 120,
      sortable: 'custom',
      overHidden: true,
    }, {
      label: '课程积分',
      prop: 'totalCourseRewardValue',
      width: 120,
      sortable: 'custom',
      overHidden: true,
    }, 
  ]
}

export const commentTableOption = {
  border: true,
  index: false,
  stripe: true,
  menu: true,
  align: 'center',
  showClomnuBtn: false,
  searchSize: 'mini',
  refreshBtn: false,
  addBtn: false,
  editBtn: false,
  delBtn: false,
  menuWidth: 120,
  menuAlign: 'center',
  column: [
    {
      label: '评论内容',
      prop: 'content',
      overHidden: true,
      width: 160,
    }, {
      label: '评论课时',
      prop: 'courseCoursewareName',
      overHidden: true,
      width: 160,
    }, {
      label: '评论人Full Name',
      prop: 'commentByName',
      overHidden: true,
      solt: true,
      width: 180,
    }, {
      label: '评论人Birth Name',
      prop: 'commentByRealname',
      overHidden: true,
      solt: true,
      width: 180,
    }, {
      label: '评论时间',
      prop: 'commentTime',
      overHidden: true,
      width: 220,
    }, {
      label: '回复对象Full Name',
      prop: 'commentToName',
      overHidden: true,
      solt: true,
      width: 240,
    }, {
      label: '回复对象Birth Name',
      prop: 'commentToRealname',
      overHidden: true,
      solt: true,
      width: 240,
    }, {
      label: '是否已下架(h)',
      prop: 'isBanned',
      dicData: commentIsBanned,
      width: 240,
    }, {
      label: '下架原因',
      prop: 'banComment',
      solt: true,
      width: 160,
    },
  ]
}

export const courswareMemberEachTimeTableOption = {
  border: true,
  index: false,
  indexLabel: '序号',
  stripe: true,
  menuAlign: 'center',
  menu: false,
  align: 'center',
  refreshBtn: false,
  showClomnuBtn: false,
  searchSize: 'mini',
  columnBtn: false,
  addBtn: false,
  editBtn: false,
  delBtn: false,
  searchBtn: false,
  searchFilterable: false,
  column: [
    {
      label: '课件名称',
      prop: 'coursewareName',
    }, {
      label: '学习时间',
      prop: 'learningTime',
    }, {
      label: '学习开始时间',
      prop: 'learningStartTime',
    }, {
      label: '学习结束时间',
      prop: 'learningEndTime',
    }
  ]
}

export const memberLearningProcessListTableOption = {
  page: false,
  border: true,
  stripe: true,
  align: 'center',
  menuAlign:'center',
  refreshBtn: false,
  delBtn: false,
  editBtn: false,
  addBtn: false,
  searchShow: false,
  searchBtn: false,
  tip: false,
  menu: false,
  indexFixed: true,
  columnBtn: false,
  column: [{
    label: '员工号',
    prop: 'unionId',
    width: 120,
    overHidden: true,
    fixed: true,
  }, {
    label: 'Birth Name',
    prop: 'realname',
    width: 160,
    overHidden: true,
    fixed: true,
  }, {
    label: 'Full Name',
    prop: 'nickName',
    overHidden: true,
    width: 160,
    fixed: true,
  }, {
    label: '手机号',
    prop: 'phoneNumber',
    width: 160,
    overHidden: true,
    solt: true,
  }, {
    label: 'Position Name',
    width: 200,
    prop: 'position',
    overHidden: true,
  }, {
    label: 'Organizational Unit Name',
    width: 200,
    prop: 'organizationalUnitName',
    overHidden: true,
  }, {
    label: '课时学习状态',
    prop: 'learningStatus',
    width: 120,
    overHidden: true,
    dicData: learningStatusOptions,
  }, {
    label: '学习进度',
    prop: 'learningProcess',
    width: 120,
    overHidden: true,
    sortable: 'custom',
    solt: true,
  }, {
    label: '学习时长（h）',
    prop: 'learningTimeH',
    width: 120,
    overHidden: true,
  }, {
    label: '用户开始时间',
    prop: 'learningStartTime',
    width: 180,
    overHidden: true,
  }, {
    label: '用户完成时间',
    prop: 'learningEndTime',
    width: 180,
    overHidden: true,
  }]
}

export const coursewarePostTableOption = {
  page:false,
  border: true,
  stripe: true,
  align:'center',
  menuAlign:'center',
  refreshBtn: false,
  delBtn: false,
  editBtn: false,
  addBtn: false,
  searchShow: false,
  searchBtn: false,
  column: [{
    label: 'ID',
    prop: 'id',
    width: 120,
  },{
    label: '内容预览',
    prop: 'title',
    overHidden: true,
    solt: true,
    align: 'left',
    width: 300,
  }, {
    label: '发布者员工号',
    prop: 'postedByUnionId',
    overHidden: true,
    align: 'left',
    width: 260,
  }, {
    label: '发布者Full Name',
    prop: 'postedByName',
    overHidden: true,
    align: 'left',
    width: 260,
  }, {
    label: '评论量',
    prop: 'commentCount',
    sortable: 'custom',
    align: 'left',
  }, {
    label: '点赞量',
    prop: 'likeCount',
    sortable: 'custom',
    align: 'left',
  }, {
    label: '发布时间',
    prop: 'postTime',
    sortable: 'custom',
    align: 'left',
  }, {
    label: '是否已下架',
    prop: 'isBanned',
    align: 'left',
    dicData: coursewarePostIsBanned,
  }, {
    label: '下架原因',
    prop: 'banComment',
    overHidden: true,
    hide: true,
    align: 'left',
  }]
}